import React from 'react';
import './TabParticipants.less';

const tableHeaders = [
  '№ п/п',
  'Полное наименование участника',
  'ИНН участника',
  'Роль участника в рамках решения задач консорциума',
  'Стратегические проект(ы), реализация которых запланирована с участием',
  'Роль участника в реализации стратеическгого(их) проекта(ов)',
];

export default function TabParticipants(props) {
  const { orgs, strategies } = props.data;
  return (
    <div className="tab-participants">
      <article>
        <div className="table">
          <table>
            <thead>
              <tr>
                {tableHeaders.map((item, i) =>
                  <th key={i}>{item}</th>)}
              </tr>
            </thead>
            <tbody>
              {orgs.map((org, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td><p className="org-title">{org.title}</p></td>
                  <td>{org.inn}</td>
                  <td>{org.roles.map((role, i) => <p key={i}>{role}</p>)}</td>
                  <td>{strategies.map((strategy, i) => <p className="strategies-names" key={i}>{strategy.name}</p>)}</td>
                  <td>{org.strategiesRoles}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </article>
    </div>
  );
}
